// extracted by mini-css-extract-plugin
export default {"main-container":"MainLayout_main-container__tYFvr","content":"MainLayout_content__A93JC"};